import React from 'react'
import PropTypes from 'prop-types'
import * as S from './ModalWindow.styled'
import Cross from '../../Icons/Cross'
import Button from '../Button/Button'
import ButtonTransparent from '../ButtonTransparent/ButtonTransparent'
import { useStore } from 'effector-react'
import { $device, Device } from 'src/processes/core/device'
import { ElementSizeType } from '@styles/theme-const'

const ModalWindow = (props) => {
    const device = useStore($device)
    const isMobile = device === Device.Mobile
    return (
        <S.AbsoluteBlock isMobile={isMobile}>
            <S.Container {...props.attrs} isMobile={isMobile}>
                <S.Header isMobile={isMobile}>
                    <S.HeaderTitle>{props.title}</S.HeaderTitle>
                    <S.ButtonClose onClick={props.cancel.clickHandler}>
                        <Cross />
                    </S.ButtonClose>
                </S.Header>
                <S.Body>{props.children}</S.Body>
                <S.Footer isHidden={!props.isButtonFooter && !props.isFooterOnlyOneButton} isMobile={isMobile}>
                    {props.footer ? props.footer : <React.Fragment />}
                    {isMobile && !props.footer ? (
                        <React.Fragment>
                            {props.submit && (
                                <Button
                                    data-submit-button
                                    elementSizeTypeValue={ElementSizeType.regular}
                                    clickHandler={props.submit.clickHandler}>
                                    {props.submit.text}
                                </Button>
                            )}
                            {props.cancel && (
                                <Button
                                    data-cancel-button
                                    elementSizeTypeValue={ElementSizeType.regular}
                                    clickHandler={props.cancel.clickHandler}>
                                    {props.cancel.text}
                                </Button>
                            )}
                        </React.Fragment>
                    ) : (
                        <React.Fragment />
                    )}
                    {!isMobile && !props.footer ? (
                        <React.Fragment>
                            {props.cancel && (
                                <ButtonTransparent data-cancel-button clickHandler={props.cancel.clickHandler}>
                                    {props.cancel.text}
                                </ButtonTransparent>
                            )}
                            {props.submit && (
                                <Button
                                    data-submit-button
                                    elementSizeTypeValue={ElementSizeType.regular}
                                    clickHandler={props.submit.clickHandler}>
                                    {props.submit.text}
                                </Button>
                            )}
                        </React.Fragment>
                    ) : (
                        <React.Fragment />
                    )}
                </S.Footer>
            </S.Container>
        </S.AbsoluteBlock>
    )
}

const buttonPropTypes = PropTypes.shape({
    text: PropTypes.string.isRequired,
    clickHandler: PropTypes.func.isRequired
})

ModalWindow.propTypes = {
    title: PropTypes.any,
    children: PropTypes.any.isRequired,
    isButtonFooter: PropTypes.bool.isRequired,
    isFooterOnlyOneButton: PropTypes.bool,
    isCustomFooter: PropTypes.bool.isRequired,
    attrs: PropTypes.any,
    footer: PropTypes.element,
    submit: buttonPropTypes,
    cancel: buttonPropTypes,
    isMobile: PropTypes.bool
}

ModalWindow.defaultProps = {
    isButtonFooter: true,
    isFooterOnlyOneButton: false,
    isCustomFooter: false,
    isMobile: false,
    submit: null,
    cancel: null,
    footer: null
}
export default ModalWindow
